// Catalog filter dropdowns (frontend.idx._filters / _registry-filters).
//
// Those bars are built from native <details> on purpose: every control is a GET
// address. What native <details> does not give is light dismiss or exclusivity —
// a panel stays open until its own <summary> is clicked again, and every chip on
// the bar can be open at once, stacking the absolutely-positioned menus on top of
// each other.
//
// This adds exactly the two missing behaviours, and nothing else: no markup
// contract, no animation, no ownership of `open`.
//
// Navigation is NOT here. A control that leads to a query string renders as a
// <span data-idx-href> (SEO decision, 2026-09-18 — see the x-frontend.idx-filter-link
// component), and the handler that follows it is inline in level.blade.php so that
// the bar moves on a click landing before this bundle has parsed.
//
// The site's spollers() accordion in app.js was the obvious candidate and does
// not fit: it slides the panel by writing inline height/overflow, which fights
// the menu's absolute positioning and its own scrollbar, and its single-open
// scope is per [data-spollers] block — the facet bar and the city/type bar are
// two blocks and would not close each other.

const DD_SELECTOR = 'details.idx-f__dd';

function openDropdowns() {
    return document.querySelectorAll(DD_SELECTOR + '[open]');
}

function closeDropdowns(except) {
    openDropdowns().forEach(function (dropdown) {
        if (dropdown !== except) {
            dropdown.open = false;
        }
    });
}

function isInsideDropdown(target) {
    return target instanceof Element && target.closest('.idx-f__dd') !== null;
}

export function initIdxFilters() {
    if (!document.querySelector(DD_SELECTOR)) {
        return;
    }

    // `toggle` does not bubble, so it is only reachable on document in the
    // capture phase. Reacting to the event rather than to the click means the
    // keyboard and any programmatic open close the others too.
    document.addEventListener('toggle', function (e) {
        const dropdown = e.target;
        if (dropdown instanceof HTMLDetailsElement
            && dropdown.open
            && dropdown.classList.contains('idx-f__dd')) {
            closeDropdowns(dropdown);
        }
    }, true);

    // pointerdown, not click: the panel has to be gone BEFORE the press lands,
    // otherwise the first click outside is spent closing the menu instead of
    // hitting the card under it. A press on the open chip's own summary, or
    // inside the menu (dragging its scrollbar), is inside .idx-f__dd and is
    // left alone — the native toggle still closes it.
    document.addEventListener('pointerdown', function (e) {
        if (!isInsideDropdown(e.target)) {
            closeDropdowns(null);
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') {
            return;
        }

        const dropdown = document.querySelector(DD_SELECTOR + '[open]');
        if (!dropdown) {
            return;
        }

        closeDropdowns(null);

        // Escape must not strand focus inside a panel that is no longer there.
        const summary = dropdown.querySelector('summary');
        if (summary) {
            summary.focus();
        }
    });
}
